import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { Physical } from '../../canvas/entities/Physical';
import { Tray } from './Tray';

export interface TrayLayout {
    base: Rect;
    items: Rect[];
    [k: string]: any;
}

export const TrayLayout = (object: Tray): TrayLayout => {

    const pad = 30;
    const gap = 20;

    const allSizes = object.polarize(Physical).map(x => x.size());
    const commonSize = new Point(
        Math.max(...allSizes.map(x => x.w)) + gap,
        Math.max(...allSizes.map(x => x.h)) + gap,
    );

    const items = object.children.map((x, i) =>
        new Rect(
            object.flow === 'row' ? pad + (gap * i) + (commonSize.w * i) : pad,
            object.flow === 'row' ? pad : pad + (gap * i) + (commonSize.h * i),
            commonSize.w,
            commonSize.h,
        )
    );

    const last = items[items.length - 1];

    const itemLookup = Object.fromEntries(items.map((x, i) => [`item:${i}`, x]));
    const base = !!last
        ? new Rect(0, 0, last.right + pad, last.bottom + pad)
        : new Rect(0, 0, pad + 150 + pad, pad + 150 + pad);

    return { base, items, ...itemLookup, } as TrayLayout;
};
